import { c as _c } from "react/compiler-runtime";
import { QAList, type Question } from '../_components/QAList';
const complaintQuestions: Question[] = [{
  title: 'Czy mogę złożyć reklamację z powodu niesatysfakcjonującej jakości zajęć?',
  content: <>
        Oczywiście! Oferujemy gwarancję satysfakcji. Jeśli nie jesteś zadowolony z{'\u00A0'}jakości
        usług, możesz złożyć reklamację <span className='whitespace-nowrap'>- sprawdzimy</span>{' '}
        nagrania i{'\u00A0'}dopasujemy usługę do Twoich potrzeb lub zwrócimy Ci pieniądze.
      </>
}, {
  title: 'Jak mogę złożyć reklamację?',
  content: <>
        Napisz do nas na{' '}
        <a href='mailto:reklamacje@algoacademy.pl' className='font-bold text-algoprimary hover:underline'>
          reklamacje@algoacademy.pl
        </a>{' '}
        w ciągu 7 dni od zajęć, które nie odpowiadały Twoim oczekiwaniom. Prosimy o przekazanie
        wszystkich szczegółów, które pomogą nam rozpatrzyć Twoją reklamację.
      </>
}, {
  title: 'W jakim czasie otrzymam odpowiedź na moją reklamację?',
  content: <>Odpowiemy najszybciej jak to możliwe - nie później niż 14 dni od zgłoszenia.</>
}, {
  title: 'Kiedy otrzymam zwrot pieniędzy po uznaniu reklamacji?',
  content: <>
        Po pozytywnym rozpatrzeniu zwrócimy pieniądze na Twoje konto - nie później niż 7 dni od
        zgłoszenia.
      </>
}];
export function QAComplaintSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={complaintQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}